import {Grid, CircularProgress, TableRow, TableCell} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {useState} from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {DayStatsCardTemplate} from '../DayReport.js';
import {TAB_REFS} from './TaxCommon.js';
import {COMM_OK} from '../WsR2.js';

const RefCard = (props) => {
	const {t} = useTranslation('obs');
	const ref = props.ref;
	
	if (!ref)
		return null;

	let refAuth = ref.author && ref.author.length ? ref.author : '';

	if (refAuth.length && ref.date && ref.date.length)
		refAuth += ', ';

	refAuth += ref.date;

	return (
		<DayStatsCardTemplate header={ref.description}>
			<TableRow>
				<TableCell align='center'>
					{refAuth}
				</TableCell>
			</TableRow>
			<TableRow>
				<TableCell align='center'>
					{ref.publication && ref.publication.length ? ref.publication : '--'}
				</TableCell>
			</TableRow>
			<TableRow>
				<TableCell align='center'>
					{ref.ref_name}
				</TableCell>
			</TableRow>
			{ref.uri && ref.uri.length &&
				<TableRow>
					<TableCell align='center'>
						<a href={ref.uri} rel="noreferrer" target="_blank">
							{t('taxons.external_link')}
						</a>	
					</TableCell>
				</TableRow>
			}
		</DayStatsCardTemplate>
	)
}

const TaxReferences = observer(() => {
	const [loading, setLoading] = useState(false);
	const gStorage = useGlobalStorage();
	const refs = gStorage.taxons.refs;

	function refsRxWs(status, msg) {
		setLoading(false);

		if (status !== COMM_OK || msg.result !== 'OK') {
			console.error('refsRxWs: error ', status, msg);
			return -1;
		}

		if (msg.cmd === 'tax' && msg.op === 'references') {
			// console.log('refsRxWs', msg.data);
			gStorage.taxons.setReferences(msg.data.references);
		} else {
			console.error('refsRxWs: unknown command', msg.cmd, msg.op, msg.result);
		}
	}

	function loadRefs(tax) {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax',
			op: 'references',
			data: {
				taxon: tax.id
			}
		};

		// console.log('loadRefs', msg);

		gStorage.conn.ws.send(msg, refsRxWs);
		setLoading(true);
	};

	if (gStorage.taxons.tab !== TAB_REFS)
		return null;

	let tax = gStorage.taxons.centerTaxon;
	if (!tax) 
		return null;

	if (!refs && gStorage.conn.online) {
		if (!loading) {
			loadRefs(tax);
			return null;
		}
	}

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:300}}>
			<Grid size={{xs: 12}} align={'center'}>
				{loading ?
					<CircularProgress sx={{mt:3}}/>
				:
				refs && refs.map((ref, ind) => {
					return (
						<RefCard 
							key={ind} 
							ref={ref} 
						/>
					)
				})}
			</Grid>
		</Grid>
	)
});

export default TaxReferences;
